import React, {Component} from 'react';
import {Col, Row} from 'react-bootstrap'
import PropTypes from "prop-types";
import {TableHeaderColumn} from "react-bootstrap-table";
import * as Date from "./utils/date"
import * as Grid from "./utils/grid";
import {hashHistory} from "react-router";
import {breadcrumbs} from "./utils";

const formatRow = (row) => {
	return "row-clickable"
};

const formatRaceTitle = (cell, row) => {
	return cell
		+ (row.raceType ? (' - ' + row.raceType) : '')
		+ (row.description ? (' - ' + row.description) : '')
};

export default class Races extends Component {


	render() {
		const {seasonId, seasons, races} = this.props;

		if (!races || races.isFetchingItem || races.items === null) {
			return Grid.renderIsFetchingData("Závody se nahrávají ...");
		}

		const cols = [
			<TableHeaderColumn key="1" dataField="title" width='60%' dataFormat={formatRaceTitle} dataAlign="left">Název</TableHeaderColumn>,
			<TableHeaderColumn key="2" dataField="location" width='25%' dataAlign="left">Místo</TableHeaderColumn>,
			<TableHeaderColumn key="3" dataField="raceDate" width='15%' dataAlign="center" dataFormat={Date.formatDate}>Datum</TableHeaderColumn>,
		];

		const filter = {};
		const options = Grid.getTableOptions(filter);
		options.onRowClick = (row) => {
			hashHistory.push('/' + row.seasonId + '/' + row.eventId + '/' + row.raceId);
		};

		let season = null;
		if (seasonId && seasons && seasons.items && seasons.items.length) {
			for (let i = 0; i < seasons.items.length; i++) {
				if (seasons.items[i].seasonId === 1 * seasonId) {
					season = seasons.items[i];
					break;
				}
			}
		}

		const bc = [];
		if (seasonId) {
			bc.push({
				url: '/' + seasonId + '/', title:
				(season ? (season.title + ' (' + Date.formatDate(season.dateFrom) + ' - ' + Date.formatDate(season.dateTo) + ')') : seasonId)
				+ ': Seznam závodů'
			});
		}

		return (
			<div>
				<Row>
					<Col xs={12}>
						{breadcrumbs(bc)}
					</Col>
				</Row>
				<Row>
					<Col xs={12}>
						{Grid.renderTable(races.items, races.items.length, options, cols, false, true, 'table-races', true, formatRow)}
					</Col>
				</Row>
			</div>
		);
	}
}


Races.propTypes = {
	seasonId: PropTypes.string,
	seasons: PropTypes.object,
	races: PropTypes.object
};



// WEBPACK FOOTER //
// ./P:/Work/htdocs/biatlon/online/src/components/Races.js